<div class="phone-input">
  <label class="phone-input__label" for="floatingInputPhone">
    {{ 'CAMPAIGN.Inputs.Phone' | translate }}<span class="text-danger">*</span>
  </label>

  <div class="phone-input__combo" role="group" aria-label="Phone number input">
    <div class="phone-input__selector-wrap">
      <button
        id="phoneCode"
        type="button"
        class="phone-input__selector"
        (click)="toggleDropdown()"
        [attr.aria-expanded]="dropdownOpen"
      >
        <span class="phone-input__selector-value">{{ getSelectedDialCodeLabel() }}</span>
        <span class="phone-input__selector-caret" aria-hidden="true"></span>
      </button>

      <div class="phone-input__dropdown dropdown-menu show" *ngIf="dropdownOpen">
        <input
          type="text"
          class="form-control phone-input__search"
          [placeholder]="'CAMPAIGN.Inputs.SearchCountryOrDialCode' | translate"
          [formControl]="searchControl"
        />

        <div class="phone-input__options">
          <button
            type="button"
            class="dropdown-item phone-input__option"
            *ngFor="let country of filteredCountries()"
            (click)="selectCountry(country.code)"
          >
            <span class="phone-input__option-label">{{ country.dialCode }} {{ country.code }}</span>
          </button>
        </div>
      </div>
    </div>

    <input
      id="floatingInputPhone"
      type="tel"
      class="form-control phone-input__control"
      [value]="phone.value"
      [disabled]="phone.disabled"
      [class.is-invalid]="showError"
      placeholder="2015551234"
      required
      inputmode="numeric"
      (input)="onPhoneInput($event)"
      (blur)="onBlur()"
    />
  </div>

  <div *ngIf="showError" class="text-danger small mt-1">
    {{ 'CAMPAIGN.Inputs.InvalidPhone' | translate }}
  </div>
</div>